import styled from '@emotion/styled';
import { device, useRevealTrail } from '@landsbankinn/ui';
import React, { Children } from 'react';

export interface IProps {
  children: React.ReactNode;
  columns?: number;
  isFeatured?: boolean;
  count?: number;
}

export const Group = styled.div<IProps>`
  flex-direction: column;

  > * {
    margin-bottom: 2em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media ${device.tablet} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 -10px -20px;

    > div,
    > a {
      margin: 0 10px;
      margin-bottom: ${(props) =>
        props.count && props.count >= 4 ? '4em' : '20px'};
      width: 100%;
      max-width: ${(props) =>
        props.count === 4
          ? 'calc(50% - 20px)'
          : `calc(${(1 / (props?.columns ?? 1)) * 100}% - 20px)`};

      &:last-child {
        margin-bottom: ${(props) =>
          props.count && props.count >= 4 ? '4em' : '20px'};
      }
    }

    > *:last-child {
      ${(props) => props.isFeatured && 'max-width: 100%;'}
    }
  }

  @media ${device.desktop} {
    > div,
    > a {
      max-width: calc(${(props) => (1 / (props?.columns ?? 1)) * 100}% - 20px);
    }
  }
`;

export const CardGroup = ({
  children,
  columns = 3,
  isFeatured = false,
}: IProps) => {
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  const count = Children.toArray(children).length;

  return (
    <Group columns={columns} count={count} ref={ref} isFeatured={isFeatured}>
      {itemsWithStyleProp}
    </Group>
  );
};
